/** Imprime HTML sin popup (los bloqueadores cierran window.open). */
export function imprimirHtml(html: string): void {
  const iframe = document.createElement('iframe');
  iframe.setAttribute('title', 'Imprimir');
  iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;opacity:0';
  document.body.appendChild(iframe);
  const doc = iframe.contentDocument ?? iframe.contentWindow?.document;
  if (!doc) {
    iframe.remove();
    throw new Error('No se pudo abrir la vista de impresión.');
  }
  doc.open();
  doc.write(html);
  doc.close();
  const go = () => {
    try {
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
    } finally {
      setTimeout(() => iframe.remove(), 2500);
    }
  };
  if (iframe.contentDocument?.readyState === 'complete') {
    setTimeout(go, 250);
  } else {
    iframe.onload = () => setTimeout(go, 250);
  }
}

/** Vista previa en pestaña; si el navegador la bloquea, imprime en esta misma página. */
export function abrirOImprimirHtml(html: string): void {
  const w = window.open('', '_blank');
  if (w) {
    w.document.open();
    w.document.write(html);
    w.document.close();
    return;
  }
  imprimirHtml(html);
}
